import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { default as __ } from '../../utils';
import { useUser } from '../../context/user';
import ScrollToTopOnMount from '../../components/utils/scroll-top';
import BackLink from '../../components/utils/back-link';
import IO from '../../components/io';
import { default as UI_ACTIONS } from '../../reducers/ui';
import { default as SESSION_ACTIONS } from '../../reducers/session';
import { gameSelector } from '../../reducers/selectors';
import { Link } from '@reach/router';
import Sidebar from '../../components/ui/sidebar';
import List from './list';

import './index.css';

const ConnectedArchive = props => {
  // let [selectedMonth, setMonth] = useState(null);
  // let [selectedYear, setYear] = useState(null);
  // let [gamesOftheMonth, setGames] = useState([]);
  // let [query, setFilter] = useState('');

  const { games, players } = props.datum;

  // let filterMonth = (m)=>{
  //     setMonth(m);
  //     let filteredOpts = games.filter(g=> g.month === m);
  //     setGames(filteredOpts)
  // }

  // let sortMonth = (query)=>{
  //      let filteredOpts;
  //      let safeQuery = query.toUpperCase();
  //   if(safeQuery === 'LEFT' || safeQuery === 'RIGHT'){
  //      filteredOpts = gamesOftheMonth
  //      .map(g=>g.players)
  //      .filter(PREDICATES[safeQuery]);

  //      console.log(filteredOpts,query);
  //   } else {
  //      filteredOpts = gamesOftheMonth.filter(PREDICATES[safeQuery]);
  //   }
  //     setGames(filteredOpts);
  //     setFilter(query);
  // }

  //     if(selectedMonth === null) return null;

  return (
    <>
      <ScrollToTopOnMount />
      <Sidebar>
        <BackLink />
      </Sidebar>

      <main className="owl">
        <List seed={games} />
      </main>

      <footer className="row-center">
        <p className="pill-button">
          <Link to="/upgrade">UPGRADE TO PRO</Link>
        </p>
      </footer>
    </>
  );
};

const select = state => {
  const datum = gameSelector(state);
  return { datum };
};

const Archive = connect(select, null)(ConnectedArchive);

export default Archive;
